import getRandomValues from '../util/getRandomValues.js';
import addRequestHeaders from './addRequestHeaders.js';

function addClientInstanceIdHeader() {
    var clientId = getRandomValues(Uint32Array ? new Uint32Array(4) : new Array(4)).join('-');
    return addRequestHeaders({ 'X-Deal-Client-Instance-ID': clientId });
}

export default addClientInstanceIdHeader;
//# sourceMappingURL=clientInstanceId.js.map
